import { Button, ButtonContainer, Callout, Checkbox, Modal, Paragraph } from '@vwfs-bronson/bronson-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

type CustomerHappinessIndexTypes = {
    handleButtonClick: () => void;
    setIsConsentAccepted: React.Dispatch<React.SetStateAction<boolean>>;
    isConsentAccepted: boolean;
};

export const CustomerHappinessIndexUi: React.FC<CustomerHappinessIndexTypes> = ({
    handleButtonClick,
    setIsConsentAccepted,
    isConsentAccepted,
}) => {
    const { t } = useTranslation('customer-happiness-index');
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <Callout headingLevel={3} title={t('title')} className={'u-mb'}>
                <Paragraph className={'u-mb'}>{t('text')}</Paragraph>
                <Checkbox
                    checked={isConsentAccepted}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setIsConsentAccepted(e.target.checked);
                    }}
                >
                    <span className="u-text-white">{t('consent-checkbox')}</span>
                </Checkbox>
                <ButtonContainer center className={'u-mt'}>
                    <Button
                        title={t('button.title')}
                        aria-label={t('button.title')}
                        onClick={() => setIsModalOpen(true)}
                        disabled={!isConsentAccepted}
                    >
                        {t('button.text')}
                    </Button>
                </ButtonContainer>
            </Callout>
            <span
                className={'u-font-size-fs-2'}
                dangerouslySetInnerHTML={{
                    __html: t('legal-notice'),
                }}
            />
            <Modal
                shown={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onCancel={() => setIsModalOpen(false)}
                onClickOutside={() => setIsModalOpen(false)}
                onConfirm={() => {
                    setIsModalOpen(false);
                    handleButtonClick();
                }}
                title={t('redirect-modal.title')}
                buttonConfirmText={t('redirect-modal.button')}
                buttonCancelText={t('redirect-modal.cancel')}
                testId={'redirect-confirmation-modal'}
            >
                <Paragraph>{t('redirect-modal.text')}</Paragraph>
            </Modal>
        </>
    );
};
